import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";

const links = [
  { href: "#servizi", label: "Servizi" },
  { href: "#lavori", label: "Lavori" },
  { href: "#offerte", label: "Offerte" },
  { href: "#recensioni", label: "Recensioni" },
  { href: "#chi-siamo", label: "Chi Siamo" },
  { href: "#contatti", label: "Contatti" },
];

export default function Header({ siteInfo }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-black/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" data-testid="brand-logo" className="flex items-center group h-full overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_garage-palumbo/artifacts/6n2dwkiq_logo%20originale%26principale.png"
            alt="Palumbo Custom Garage"
            className="h-[160px] sm:h-[180px] w-auto object-contain -my-12 scale-110"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={isHome ? l.href : `/${l.href}`}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-300 hover:text-palumbo-copper transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={waLink(siteInfo?.whatsapp)}
          target="_blank"
          rel="noreferrer"
          data-testid="header-whatsapp-btn"
          className="hidden md:inline-flex items-center gap-2 bg-palumbo-copper hover:bg-palumbo-copper-dark text-white font-bold uppercase tracking-wide text-xs px-5 py-3 transition-colors"
        >
          <MessageCircle size={16} strokeWidth={2} /> WhatsApp
        </a>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-white"
          data-testid="mobile-menu-toggle"
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={isHome ? l.href : `/${l.href}`}
                onClick={() => setOpen(false)}
                className="text-sm font-bold uppercase tracking-widest text-neutral-200 hover:text-palumbo-copper"
              >
                {l.label}
              </a>
            ))}
            <a
              href={waLink(siteInfo?.whatsapp)}
              target="_blank"
              rel="noreferrer"
              className="bg-palumbo-copper text-white text-center font-bold uppercase tracking-wide text-xs px-5 py-3 mt-2"
              data-testid="mobile-whatsapp-btn"
            >
              Contattaci su WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
